import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-member-avatar',
  standalone: false,
  templateUrl: './member-avatar.component.html',
  styleUrls: ['./member-avatar.component.scss'],
})
export class MemberAvatarComponent {
  @Input() public userName = '';
}
